import { render, staticRenderFns } from "./SelectVideoModal.vue?vue&type=template&id=f5f80036&scoped=true"
import script from "./SelectVideoModal.vue?vue&type=script&lang=ts"
export * from "./SelectVideoModal.vue?vue&type=script&lang=ts"
import style0 from "./SelectVideoModal.vue?vue&type=style&index=0&id=f5f80036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f80036",
  null
  
)

export default component.exports